import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

import SubmitButton from 'components/Widgets/SubmitButton';

export default function FormFooter({ loading, onCancel, buttonName }) {
  return (
    <footer className="footer-flex">
      <Button
        variant="outline-primary"
        disabled={loading}
        onClick={onCancel}
      >
        Cancel
      </Button>

      <SubmitButton loading={loading}>
        {buttonName}
      </SubmitButton>
    </footer>
  );
}

FormFooter.propTypes = {
  loading: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  buttonName: PropTypes.string,
};

FormFooter.defaultProps = {
  buttonName: 'Save',
};
